import { getCurrentPrice } from '@utils/helper'

export default function AfterpayMessage({ data }: any) {
  const isSpecialOrder =
    data?.flags?.includes('special_order') ||
    data.stock_type === 'Special Order'

  const priceDetails = {
    special_price: data?.special_price,
    special_from_date: data?.special_from_date,
    special_to_date: data?.special_to_date,
    price: data?.price,
  }

  const currentPrice = getCurrentPrice(priceDetails)

  return (
    data?.is_in_stock &&
    !isSpecialOrder && (
      <afterpay-placement
        data-locale="en_CA"
        data-badge-theme="black-on-mint"
        data-amount={currentPrice}
      ></afterpay-placement>
    )
  )
}
